import React from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import {makeStyles} from '@material-ui/core';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import DoubleButton from '../components/DoubleButton';
import TextInput from 'components/TextInput';
import * as Yup from 'yup';
import validationShema from 'constants/ValidationShema';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import InputLimits from "constants/InputLimits";

const useStyle = makeStyles(theme => ({
    padding: {
        marginTop: theme.spacing(2)
    }
}));

function InvalidateDemandPopup(
    {
        open,
        onClose,
        onSubmit,
        title = 'cancel',
        type = 'invalidate',
        formSubmit
    }) {

    const classes = useStyle();
    const formId = useId();


    const handleSubmit = () => formSubmit[formId]()

    return (
        <Dialog
            title={Tr(type + '_demand')}
            open={open}
            maxWidth={'md'}
        >
            <Form
                initialValues={{
                    comment: ""
                }}
                validationSchema={Yup.object().shape({
                    comment: validationShema.stringMax(InputLimits.procedure.documents.NAME),
                })}
                onSubmit={onSubmit}
                id={formId}
            >
                {(formikProps) => (
                    <GridBlock column>
                        <TextInput
                            id='comment'
                            formikProps={formikProps}
                            label={Tr(type + '_demand_comment')}
                            multiline
                        />

                        <div className={classes.actions}>
                            <DoubleButton
                                justify='flex-end'
                                labelFirst={Tr(title)}
                                labelSecond={Tr(type)}
                                onClickFirst={onClose}
                                onClickSecond={handleSubmit}
                            />
                        </div>
                    </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(InvalidateDemandPopup);